export const state = {
  user: {},
  loadingProfile: true,
  updatingProfile: false,
  readNotification: {read: false}
}

